module.exports = __webpack_public_path__ + "img/prod-2.679f785e.jpg";